export default "__VITE_ASSET__DBlYWEwL__"